import {useQuery} from '@tanstack/react-query';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {apiClient} from '@common/http/query-client';
import {useParams} from 'react-router-dom';
import {Chat} from '../../../chats/chat';

const Endpoint = (id: number | string) => `chats/${id}`;

export interface FetchRoleResponse extends BackendResponse {
   chat: Chat;
}

export function useChat() {
  const { chatId} = useParams();
  return useQuery({
    queryKey: [Endpoint( chatId!)],
    queryFn: () => fetchChat( chatId!),
  });
}

function fetchChat( chatId: number | string): Promise<FetchRoleResponse> {
  return apiClient.get(Endpoint( chatId)).then(response => response.data);
}
